import { getSettings } from '../lib/data.js';
import { esc } from '../lib/utils.js';

export async function renderONas(view) {
    const settings = await getSettings();
    const intro = settings.intro_text || '';
    // {ROK} v textu se nahradí aktuálním rokem — text se tak nezestará.
    const about = (settings.about_text || '').replace('{ROK}', new Date().getFullYear());
    const refIntro = settings.references_intro || '';
    const refPlaces = settings.references_places || '';

    // Popis kapely (intro_text) je první odstavec, pak následuje historie.
    const fullText = [intro, about].filter(Boolean).join('\n\n');

    view.innerHTML = `
        <section class="section narrow">
            <h1 class="page-title">O nás</h1>
            <div class="article-body">${paragraphs(fullText)}</div>
        </section>

        ${refPlaces ? `
        <section class="section narrow">
            <h2 class="section-title">Reference</h2>
            ${refIntro ? `<p class="page-lead">${esc(refIntro)}</p>` : ''}
            <div class="ref-places">${esc(refPlaces)}</div>
        </section>` : ''}
    `;
}

function paragraphs(text) {
    return (text || '').split(/\n\s*\n/).map((p) =>
        `<p>${esc(p.trim()).replace(/\n/g, '<br>')}</p>`
    ).join('');
}
